// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eWe\\+v {\n  padding: unset;\n\n  /* Design spec  */\n  max-height: 300px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n._3\\+kEj {\n  padding: var(--spacing-xs) var(--spacing-sm);\n\n  /* Offset padding from parent container */\n  margin-left: -12px;\n  width: calc(100% + var(--spacing-xt-md));\n}\n\n._3\\+kEj:hover {\n  cursor: pointer;\n  background-color: var(--color-blue-extra-light);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "eWe+v",
	"listItem": "_3+kEj"
};
export default ___CSS_LOADER_EXPORT___;
